import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonWebService, UserHttpService } from '../../../utils/common-services';
import { UserType } from '../../../utils/enums';

@Component({
  selector: 'intrasense-not-found-page',
  templateUrl: './not-found-page.component.html',
  styleUrls: ['./not-found-page.component.scss']
})
export class NotFoundPageComponent implements OnInit {

  constructor(
    private router: Router,
    private loginService: CommonWebService,
    private userService: UserHttpService
  ) { }

  ngOnInit(): void {
  }

  navigateTo(event: boolean) {
    if(event) {
      if(this.userService.getUserInfo && this.userService.getUserInfo.user_id) {
        this.userService.getUserInfo.user_type == UserType.VENDOR ? this.router.navigate(['/user/manage-orders/rfq']) : this.router.navigate(['/user/clients']);
      } else {
        this.loginService.logout();
      }
    } else {
      this.router.navigate(['/']);
      this.loginService.logout();
    }
    
  }
}
